module.exports = __webpack_public_path__ + "img/Misi Working Style-Header.77b14973.png";